<template>
  <DownloadSchemaButton
    :isDownloadable="Boolean(isDownloadable && loggedIn)"
    :isCurated="isCurated"
    v-bind="$attrs"
    @click="open = Boolean(isDownloadable)"
  />
  <LazyDownloadSchemaModal
    v-model="open"
    :allDefaultOpen="allDefaultOpen"
    :preselectedIds="preselectedIds"
  />
</template>

<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

withDefaults(
  defineProps<{
    isCurated?: boolean;
    isDownloadable?: boolean;
    folId?: number;
    allDefaultOpen?: boolean;
    preselectedIds?: number[];
  }>(),
  {
    isCurated: false,
    isDownloadable: true,
    folId: undefined,
    allDefaultOpen: false,
    preselectedIds: () => [],
  }
);

const open = ref(false);
const { loggedIn } = storeToRefs(useUserStore());

const LazyDownloadSchemaModal = defineAsyncComponent(
  () =>
    import(
      "~/components/legaltextparagraph/schema/download/DownloadSchemaModal.vue"
    )
);
</script>
